import { render, staticRenderFns } from "./LanternPatternDialog.vue?vue&type=template&id=799f1b6f&scoped=true&"
import script from "./LanternPatternDialog.vue?vue&type=script&lang=js&"
export * from "./LanternPatternDialog.vue?vue&type=script&lang=js&"
import style0 from "./LanternPatternDialog.vue?vue&type=style&index=0&id=799f1b6f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f1b6f",
  null
  
)

export default component.exports